import { Component, OnInit } from '@angular/core';
import { OpenIdService } from 'src/app/service/open-id.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-component-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css'],
})
export class UserComponent implements OnInit {
    public userProfile?: any;
    public logoutUrl?: string;
    public profileUrl: string;
    constructor(private openIdService: OpenIdService) {
        let kc = environment.keycloak;
        this.profileUrl = `${kc.host}/realms/${kc.realm}/account/#/`;
    }

    ngOnInit(): void {
        this.openIdService.$userProfile.subscribe((userProfile) => {
            if (!userProfile) return;
            this.userProfile = userProfile;
            this.logoutUrl = this.openIdService.keycloak.createLogoutUrl();
        });
    }
}
